import { callApi } from './common'

function list() {
  return callApi('ccy/exchangerate')
}

function makeString(name, arr) {
  let str = ''
  arr.forEach((item) => {
    str += `&${name}[]=${item}`
  })

  return str
}

function getLatestByCodes(codes) {
  const codeStr = makeString('codes', codes)
  return callApi(`ccy/exchangerate?${codeStr}&limit=${codes.length}&sort=-date`)
}

function getByCodesDate(codes, date) {
  const codeStr = makeString('codes', codes)
  return callApi(`ccy/exchangerate?${codeStr}&date=${date}`)
}

function getByCodesDates(codes, dates) {
  const str = makeString('dates', dates)
  const codeStr = makeString('codes', codes)
  return callApi(`ccy/exchangerate?${codeStr}${str}`)
}

export default {
  list,
  getLatestByCodes,
  getByCodesDate,
  getByCodesDates,
}
